"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adobeAnalyticsConfig = void 0;
const env_1 = require("../env/env");
exports.adobeAnalyticsConfig = {
    ADOBE_ANALYTICS_URL: env_1.env.getString('ADOBE_ANALYTICS_URL') ||
        '//assets.adobedtm.com/348995220a3c/77f7437e78d4/launch-ea7f8516f48b-development.min.js',
};
//# sourceMappingURL=adobeAnalyticsConfig.js.map